import React from "react";

function ReplyPreview({ reply }) {
  return (
    <div className="reply-preview">
      <small className="text-muted">
        Replying to: {reply.text || "Media message"}
      </small>
    </div>
  );
}

export default ReplyPreview;